module.exports = __webpack_public_path__ + "media/images/emblems/Courtetelle-blason-e001ea3a849a2bf2113b33fbb0fc837d.png";